import _, { identity } from 'lodash';

/** Returns true if x is between the range. */
export function isBetween(x: number, range: [number, number], inclusive = true): boolean {
  const [start, end] = _.sortBy(range, identity);
  if (inclusive) {
    return x >= start && x <= end;
  } else return x > start && x < end;
}
